import React, { FC, useEffect, useState } from 'react';
import styles from './guideText.module.scss';
import classNames from 'classnames/bind';
import useInterviewPracticeStore from '@stores/InterviewStore/InterviewPracticeStore';
import { shallow } from 'zustand/shallow';

const cx = classNames.bind(styles);

interface GuidTextProps {
  children: React.ReactNode;
  onMount?: () => void;
}

export const GuideText: FC<GuidTextProps> = ({ children, onMount }) => {
  const toNextStep = useInterviewPracticeStore((state) => state.practiceStepInfo.toNextStep, shallow);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    onMount?.();

    setTimeout(() => setEnabled(true), 300);
    setTimeout(() => setEnabled(false), 4500);
    setTimeout(() => toNextStep(), 5000);
  }, []);

  return <div className={cx('guideText', { enabled })}>{children}</div>;
};
